import { useI18n } from '../../i18n';

/**
 * Shown in place of catalog content (milestone/activity/leap/joke/gear text)
 * when the chosen non-English language has no translation yet. UI chrome still
 * falls back to English; this message is reserved for missing *content*.
 */
export function MissingText({ className = '' }: { className?: string }) {
  const { t } = useI18n();
  return (
    <p className={['text-[13px] italic text-ink-3', className].join(' ')}>
      {t('common.missingText', 'Sorry, we are working to provide the texts.')}
    </p>
  );
}

/**
 * True when a catalog row's text should be replaced by <MissingText/>: a
 * non-English locale is active and the row has no translation in it. Rows from
 * older backends (no `has_translation` field) are treated as present.
 */
export function useIsUntranslated(): (row: { has_translation?: boolean } | null | undefined) => boolean {
  const { locale } = useI18n();
  return (row) => locale !== 'en' && row != null && row.has_translation === false;
}
